import noop from 'lodash/noop';

import { getInDomain } from '../domains/externalUtils';

export function enterPaypalComplete() {
  return getInDomain('payments.actions.enterPaypalComplete')();
}

export function enterSubscriptionManagement() {
  return getInDomain('payments.actions.enterSubscriptionManagement')();
}

export function enterFamilyPlanManagement({ currentPath }) {
  return getInDomain('payments.actions.enterFamilyPlanManagement')({
    currentPath,
  });
}

export function enterPartnerUpgradeFlow() {
  return getInDomain('payments.actions.enterPartnerUpgradeFlow')();
}

export function setPaypalComplete() {
  return getInDomain('payments.actions.setPaypalComplete')();
}

export function clearSelectedOffer() {
  return getInDomain('payments.actions.clearSelectedOffer')();
}

export function upgradeOffered({ sourceType, sourceId }) {
  // noop in order to avoid an error if `payments.actions.upgradeOffered` is not defined
  // which is ok bc this currently only used for analytics.
  return getInDomain('payments.actions.upgradeOffered', noop)({ sourceType, sourceId });
}

export function processUpgradeAuthentication({ tierSlug, subTierSlug }) {
  return getInDomain('payments.actions.processUpgradeAuthentication')({
    tierSlug,
    subTierSlug,
  });
}

export function processUpgrade({ tierSlug, subTierSlug }) {
  return getInDomain('payments.actions.processUpgrade')({
    tierSlug,
    subTierSlug,
  });
}

export function waitForSubscriptionInfo() {
  // noop to avoid error if payments is not loaded
  // this is OK in this case because this will only be used for analytics
  return getInDomain('payments.actions.waitForSubscriptionInfo', noop)();
}
